import {Injectable} from '@angular/core';
import {SubjectCategoriesResponse, SubjectCategory} from '@npck/af-frontend-api';
import {RouterService} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {FilterEvent, SearchPlaceholderContext} from '../components/full-table/filter/filter.component';
import {initialTableEvent, TableEvent} from '../components/full-table/full-table.component';
import {Row} from '../components/full-table/table/table.component';
import {AF_CENTRE_TABS, AfCentreTab} from '../pages/af-centre/af-centre.component';
import {Path} from '../path';

@Injectable({providedIn: 'root'})
export class AfCentreFilterHolderService {
    private tabs: AfCentreTab[] = AF_CENTRE_TABS;

    private tabTableHolder = this.initialState();

    constructor(
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.AF_CENTRE) && !event.url.includes(Path.SUBJECTS)) {
                    this.clear();
                }
            });
    }

    storeTableState(tab: AfCentreTab, tableEvent: TableEvent): AfCentreTabInfo {
        this.tabTableHolder[tab] = {...this.tabTableHolder[tab], tableEvent};
        return this.tabTableHolder[tab];
    }

    storeResponse(tab: AfCentreTab, response: SubjectCategoriesResponse, dataSource: Row[]): void {
        this.tabTableHolder[tab] = {...this.tabTableHolder[tab], response, dataSource, cachedTime: dayjs()};
    }

    getState(tab: AfCentreTab): AfCentreTabInfo {
        return this.tabTableHolder[tab];
    }

    clear(): void {
        this.tabTableHolder = this.initialState();
    }

    getPlaceholderContext(tab: AfCentreTab): SearchPlaceholderContext {
        switch (tab) {
            case 'tabVictim':
            case 'tabDropper':
            case 'tabPotentialVictim':
            case 'tabWhiteList':
                return 'af_centre';
            default:
                return null;
        }
    }

    getDefaultFilterForTab(tab: AfCentreTab): FilterEvent {
        switch (tab) {
            case 'tabVictim':
                return {category: {[SubjectCategory.VICTIM]: true}};
            case 'tabDropper':
                return {category: {[SubjectCategory.DROPPER]: true}};
            case 'tabPotentialVictim':
                return {category: {[SubjectCategory.POTENTIAL_VICTIM]: true}};
            case 'tabWhiteList':
                return {category: {[SubjectCategory.WHITE_LIST]: true}};
            default:
                return {};
        }
    }

    private initialState(): Record<AfCentreTab, AfCentreTabInfo> {
        return this.tabs.reduce((acc, item) => {
            if (!acc[item]) {
                acc[item] = <AfCentreTabInfo>{
                    tableEvent: {
                        ...initialTableEvent,
                        filter: {},
                    },
                    placeholderContext: this.getPlaceholderContext(item),
                };
            }
            return acc;
        }, {} as Record<AfCentreTab, AfCentreTabInfo>);
    }
}

export interface AfCentreTabInfo {
    tableEvent: TableEvent;
    placeholderContext: SearchPlaceholderContext;
    response?: SubjectCategoriesResponse;
    dataSource?: Row[];
    cachedTime: dayjs.Dayjs;
}
